import React from "react";
import DateTimeInput from "../fields/DateTimeInput";

const EmergencyRoomResultSection = ({ formData, setFormData }) => {
  return (
    <section className="form-section">
      <h3>3-4. 응급실 심폐소생술 결과</h3>

      {/* 심폐소생술 중단 시각 및 수액 투여량 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">심폐소생술 중단 시각</label>
          <div className="input_2col">
            <DateTimeInput
              id="ED_stop_datetime"
              value={formData.ED_stop_datetime || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, ED_stop_datetime: datetime })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">심폐소생술 중 수액 투여량</label>
          <div className="input_2col">
            <div className="input-with-unit">
              <input
                type="text"
                id="ED_fluid"
                value={formData.ED_fluid || ""}
                onChange={(e) =>
                  setFormData({ ...formData, ED_fluid: e.target.value })
                }
              />
              <span className="unit-text">ml</span>
            </div>
          </div>
        </div>
      </div>

      {/* 심폐소생술 중단 이유 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">심폐소생술 중단 이유</label>
          <div className="input_1col">
            {["ROSC", "사망", "DNR"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="ED_stop_cause"
                  value={value}
                  checked={formData.ED_stop_cause === value}
                  onChange={(e) =>
                    setFormData({ ...formData, ED_stop_cause: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 심정지 원인 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">심정지 원인</label>
          <div className="input_1col">
            {[
              "내과적, 심장 원인",
              "내과적, 심장 원인이 아님",
              "Trauma",
              "Asphyxial",
              "Drug overdose",
              "Drowning",
              "non-Electrocusion",
              "온열/한랭손상",
            ].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="Cause_arrest"
                  value={value}
                  checked={formData.Cause_arrest === value}
                  onChange={(e) =>
                    setFormData({ ...formData, Cause_arrest: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 심정지 비심인성 원인 */}
      {formData.Cause_arrest === "내과적, 심장 원인이 아님" && (
        <div id="Cause_medical_container" className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">심정지 비심인성 원인</label>
            <div className="input_1col">
              {[
                "뇌혈관질환",
                "급성대동맥증후군",
                "위장관출혈",
                "감염/패혈증",
                "폐색전증",
                "아나필락시스",
                "말기 암",
                "전해질 불균형 (Hyperkalemia, Hypokalemia)",
                "기타 (presumed cardiac 에 해당되지 않는 경우, shockable rhythm 보이지 않고 갑자기 쓰러진 모습이 목격되지 않았을 때)",
              ].map((value) => (
                <label key={value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="Cause_medical"
                    value={value}
                    checked={formData.Cause_medical === value}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        Cause_medical: e.target.value,
                      })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{value}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* 심정지 외상성 원인 */}
      {formData.Cause_arrest === "Trauma" && (
        <div id="Cause_trauma_container" className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">
              심정지 외상성 원인 (Blunt/Penetrating)
            </label>
            <div className="input_1col">
              {["둔상", "관통상", "화상"].map((value) => (
                <label key={value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="Cause_trauma"
                    value={value}
                    checked={formData.Cause_trauma === value}
                    onChange={(e) =>
                      setFormData({ ...formData, Cause_trauma: e.target.value })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{value}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* 심정지 질식 원인 */}
      {formData.Cause_arrest === "Asphyxial" && (
        <div id="Cause_asphyxia_container" className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">심정지 질식 원인</label>
            <div className="input_1col">
              {["이물질로 인한 기도폐쇄", "목맴", "목졸림(교살)"].map(
                (value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="Cause_asphyxia"
                      value={value}
                      checked={formData.Cause_asphyxia === value}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          Cause_asphyxia: e.target.value,
                        })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                )
              )}
            </div>
          </div>
        </div>
      )}

      {/* ROSC 관련 필드들 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">ROSC 여부, 장소 관계 없음</label>
          <div className="input_2col">
            {["No", "Not sustained", "Sustained (20분 이상)"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="ROSC"
                  value={value}
                  checked={formData.ROSC === value}
                  onChange={(e) =>
                    setFormData({ ...formData, ROSC: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">ROSC, 응급실에서만</label>
          <div className="input_2col">
            {["No", "Not sustained", "Sustained (20분 이상)"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="ED_ROSC"
                  value={value}
                  checked={formData.ED_ROSC === value}
                  onChange={(e) =>
                    setFormData({ ...formData, ED_ROSC: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* ROSC 시각 관련 필드들 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Not sustained ROSC (응급실 내에서, 시각)
          </label>
          <div className="input_2col">
            <DateTimeInput
              id="ED_nonsust_ROSC_datetime"
              value={formData.ED_nonsust_ROSC_datetime || ""}
              onChange={(datetime) =>
                setFormData({
                  ...formData,
                  ED_nonsust_ROSC_datetime: datetime,
                })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">
            Sustained ROSC (응급실 내에서, 시각)
          </label>
          <div className="input_2col">
            <DateTimeInput
              id="ED_sust_ROSC_datetime"
              value={formData.ED_sust_ROSC_datetime || ""}
              onChange={(datetime) =>
                setFormData({
                  ...formData,
                  ED_sust_ROSC_datetime: datetime,
                })
              }
            />
          </div>
        </div>
      </div>

      {/* ROSC 심전도 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">ROSC 심전도</label>
          <div className="input_1col">
            {[
              "STEMI",
              "ST depression",
              "LBBB",
              "RBBB",
              "Non specific ST or T patterns",
              "Normal ST segment a T wave",
              "Prolonged QT",
              "Others",
            ].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="ED_ROSC_ECG"
                  value={value}
                  checked={formData.ED_ROSC_ECG === value}
                  onChange={(e) =>
                    setFormData({ ...formData, ED_ROSC_ECG: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 결과 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">결과</label>
          <div className="input_1col">
            {["사망", "입원", "Transfer", "Hopeless discharge"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="ED_disposition"
                  value={value}
                  checked={formData.ED_disposition === value}
                  onChange={(e) =>
                    setFormData({ ...formData, ED_disposition: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 사망 상세 정보 */}
      {formData.ED_disposition === "사망" && (
        <div id="Dead_container" className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">사망</label>
            <div className="input_1col">
              {[
                "ROSC 없이 사망",
                "Sustained ROSC 없이 사망",
                "Sustained ROSC 되었으나 사망",
                "DNR로 치료 중단 후 사망",
              ].map((value) => (
                <label key={value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="Dead"
                    value={value}
                    checked={formData.Dead === value}
                    onChange={(e) =>
                      setFormData({ ...formData, Dead: e.target.value })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{value}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* 입원 상세 정보 */}
      {formData.ED_disposition === "입원" && (
        <div id="Admission_container" className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">입원</label>
            <div className="input_1col">
              {["ICU 입원", "Semi ICU 입원", "일반병실 입원"].map((value) => (
                <label key={value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="Admission"
                    value={value}
                    checked={formData.Admission === value}
                    onChange={(e) =>
                      setFormData({ ...formData, Admission: e.target.value })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{value}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* NCV 검사 결과 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">NCV 응급용 선별검사</label>
          <div className="input_1col">
            {["Positive", "Negative", "Indeterminate", "시행하지않음"].map(
              (value) => (
                <label key={value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="NCV_em"
                    value={value}
                    checked={formData.NCV_em === value}
                    onChange={(e) =>
                      setFormData({ ...formData, NCV_em: e.target.value })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{value}</div>
                </label>
              )
            )}
          </div>
        </div>
      </div>

      {/* NCV 정규검사 추가 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">NCV 정규검사</label>
          <div className="input_1col">
            {["Positive", "Negative", "Indeterminate", "시행하지않음"].map(
              (value) => (
                <label key={value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="NCV"
                    value={value}
                    checked={formData.NCV === value}
                    onChange={(e) =>
                      setFormData({ ...formData, NCV: e.target.value })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{value}</div>
                </label>
              )
            )}
          </div>
        </div>
      </div>

      {/* 기록지 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">초진 기록지</label>
          <div className="input_1col">
            <textarea
              id="admission_memo"
              value={formData.admission_memo || ""}
              onChange={(e) =>
                setFormData({ ...formData, admission_memo: e.target.value })
              }
            />
          </div>
        </div>
      </div>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">응급실 퇴실 기록지</label>
          <div className="input_1col">
            <textarea
              id="discharge_memo"
              value={formData.discharge_memo || ""}
              onChange={(e) =>
                setFormData({ ...formData, discharge_memo: e.target.value })
              }
            />
          </div>
        </div>
      </div>

      {/* Re-arrest 관련 필드들 */}
      {[1, 2, 3].map((num) => (
        <React.Fragment key={num}>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">{num}st re-arrest 여부</label>
              <div className="input_2col">
                {["예", "아니오"].map((value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name={`ROSC${num}_Re_arrest`}
                      value={value}
                      checked={formData[`ROSC${num}_Re_arrest`] === value}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [`ROSC${num}_Re_arrest`]: e.target.value,
                        })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                ))}
              </div>
            </div>
            {formData[`ROSC${num}_Re_arrest`] === "예" && (
              <div className="block-2column">
                <label className="item_title_2col">
                  {num}st re-arrest time
                </label>
                <div className="input_2col">
                  <DateTimeInput
                    id={`ROSC${num}_Re_arrest_datetime`}
                    value={formData[`ROSC${num}_Re_arrest_datetime`] || ""}
                    onChange={(datetime) =>
                      setFormData({
                        ...formData,
                        [`ROSC${num}_Re_arrest_datetime`]: datetime,
                      })
                    }
                  />
                </div>
              </div>
            )}
          </div>
          {formData[`ROSC${num}_Re_arrest`] === "예" && (
            <div className="input-wrapper-2column">
              <div className="block-2column">
                <label className="item_title_2col">
                  {num}st re-arrest ROSC
                </label>
                <div className="input_2col">
                  {["No", "Not sustained", "Sustained (20분 이상)"].map(
                    (value) => (
                      <label key={value} className="rad-label">
                        <input
                          type="radio"
                          className="rad-input"
                          name={`${num}st_rearrest_ROSC`}
                          value={value}
                          checked={formData[`${num}st_rearrest_ROSC`] === value}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              [`${num}st_rearrest_ROSC`]: e.target.value,
                            })
                          }
                        />
                        <div className="rad-design"></div>
                        <div className="rad-text">{value}</div>
                      </label>
                    )
                  )}
                </div>
              </div>
              {formData[`${num}st_rearrest_ROSC`] ===
                "Sustained (20분 이상)" && (
                <div className="block-2column">
                  <label className="item_title_2col">
                    {num}st re-arrest Sustained ROSC time
                  </label>
                  <div className="input_2col">
                    <DateTimeInput
                      id={`${num}st_rearrest_susROSC_datetime`}
                      value={
                        formData[`${num}st_rearrest_susROSC_datetime`] || ""
                      }
                      onChange={(datetime) =>
                        setFormData({
                          ...formData,
                          [`${num}st_rearrest_susROSC_datetime`]: datetime,
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </React.Fragment>
      ))}
    </section>
  );
};

export default EmergencyRoomResultSection;
